// Translation: Error > Landing > Message (Russian)
export default Object.freeze({
	fallback: {
		title: ''
	}
})
